import { BearbeitungsstatusSelection } from '../../../../core/gb-api/model/bearbeitungsstatusSelection';
import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-bearbeitungsstatus-selection',
  templateUrl: './bearbeitungsstatus-selection.component.html',
  styleUrls: ['./bearbeitungsstatus-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BearbeitungsstatusSelectionComponent),
      multi: true
    }
  ],
  imports: [CapFormRowDirective, CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class BearbeitungsstatusSelectionComponent {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() disabled = false;

  model: BearbeitungsstatusSelection;
  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {}

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
